import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'

import { AuthStore } from '@yoshu-lib/core/auth/auth.store'

export const authGuard: CanActivateFn = () => {
  const authStore = inject(AuthStore)
  const router = inject(Router)

  if (!authStore.isLoggedIn()) {
    router.navigate(['/login'])
    return false
  }

  return true
}
